import { all, call, put, select, race } from 'redux-saga/effects';
import { fetchReceipts } from 'modules/Checks/api';
import { getFormValues } from 'redux-form/immutable';
import { getChecksSuccess } from 'modules/Taps/components/NDFL3/NDFL3Actions';
import {
  actionTypes as propertyObjectsActionTypes,
  startRequest as getPropertyObjects,
} from 'modules/App/redux/propertyObjects/actions';
import { startRequest as getPropertyObjectTypes } from 'modules/App/redux/propertyObjectTypes/actions';
import { BASE_ACTIONS } from 'modules/Taps/redux/ndfl3Saga/NDFL3SagaActionTypes';
import { STEP_DEDUCTION_FORM } from 'modules/Taps/components/NDFL3LightIIS/constants';
import {
  initializeFailure,
  starStepFetching,
  stopStepFetching,
} from 'modules/Taps/components/NDFL3Light/redux/actions';
import REACT_CONFIG from 'REACT_CONFIG';

export function* initDeductionsSaga() {
  const formData = yield select(getFormValues(STEP_DEDUCTION_FORM));
  const reportYear = formData.getIn(['payload', 'initialData', 'reportYear']);

  yield put(starStepFetching());

  yield all([
    put(getPropertyObjects()),
    put(getPropertyObjectTypes()),
    BASE_ACTIONS.GET_PROPERTY_RIGHTS.sagaFunction({}),
    BASE_ACTIONS.GET_OBJECT_NAME_CODES.sagaFunction({}),
    BASE_ACTIONS.GET_TAX_DEDUCTION_OWNER_CODES.sagaFunction({
      payload: { year: reportYear },
    }),
  ]);

  const { success } = yield race({
    success: propertyObjectsActionTypes.REQUEST_SUCCESS,
    error: propertyObjectsActionTypes.REQUEST_FAILURE,
  });

  if (success) {
    if (!REACT_CONFIG.REACT_APP_HIDE_CHECKS) {
      const checks = yield call(fetchReceipts);
      yield put(getChecksSuccess(checks));
    }
  } else {
    yield put(initializeFailure({ description: 'initializeError' }));
  }

  yield put(stopStepFetching());
}
